/**
 * SSOT for the Party naming invariant (see the `Party` docblock in types/party.ts):
 *  - PF: displayName = civil name, as typed.
 *  - PJ: displayName = tradeName; falls back to legalName; falls back to an
 *    explicit displayName only when the writer sent neither.
 *
 * PJ writers (seeds, imports, mobile) send tradeName/legalName and no displayName,
 * so the name must be derived **before** validation — `validateParty` requires
 * displayName. Callers: partyService.create/updateParty, the console form's
 * `toDomain`, and the legacy row mappers (which layer ERP-only fallbacks on top).
 */
export function derivePartyDisplayName(data) {
    const explicit = (data.displayName ?? '').trim();
    if (data.partyType === 'PJ') {
        const trade = (data.tradeName ?? '').trim();
        const legal = (data.legalName ?? '').trim();
        return trade || legal || explicit;
    }
    return explicit;
}
/**
 * Applies the naming invariant to a write payload. Validate and persist the
 * result of this — never the raw input.
 */
export function normalizePartyWrite(data) {
    return { ...data, displayName: derivePartyDisplayName(data) };
}
//# sourceMappingURL=partyNaming.js.map